import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { tokenStripe } from '../../../resources/Stripe/actions';
import { fetchOrganization } from '../../../resources/Organization/actions';
import { Container, View } from '../../../components';
import { Button, Layout, Result } from 'antd';
import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';
import qs from 'qs';

const { Content } = Layout;

const Authorize = ({ tokenStripe, location, organization }) => {
	const intl = useIntl();
	const query = location.search.slice(1);
	const [result, setResult] = useState(false);

	useEffect(() => {
		const fetchData = async () => {
			if (organization?._id) {
				if (!organization?.data?.data?.stripeAccountId) {
					const code = qs.parse(query).code;
					const state = qs.parse(query).state;
					await tokenStripe('organization', code, state);
				}
				setResult({
					status: 'success',
					title: 'Stripe Authorization Successful',
					subTitle:
						'Your connection to Stripe has been successfully Authorised. You may start using all of the features that requires payment',
					extra: [
						<Button type="primary" key="console">
							Home
						</Button>,
					],
				});
			}
		};

		fetchData();
	}, [organization]);

	return (
		<Content>
			<Helmet>
				<title>
					{intl.formatMessage({
						id: 'common.token',
						defaultMessage: 'Token',
					})}
				</title>
			</Helmet>

			<View>
				<Container>{result && <Result {...result} />}</Container>
			</View>
		</Content>
	);
};

const mapStateToProps = ({ organization }) => {
	return {
		organization,
	};
};

export default connect(mapStateToProps, { tokenStripe, fetchOrganization })(
	Authorize
);
